// extracted by mini-css-extract-plugin
export default {"form":"PatientStep7_form__mJ2Nr","skip":"PatientStep7_skip__wjL6P"};